import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  communicationPlans: [],
  pageLoading: false,
  communicationPlanStatusLoading: false,
  report: "",
  communicationPagination: {},
});

export default function communicationReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.COMMUNICATION_PLAN.PENDING: {
      return state
        .set("error", "")
        .set("communicationPlans", [])
        .set("pageLoading", true);
    }
    case ACTIONS.COMMUNICATION_PLAN.SUCCESS: {
      return state
        .set("pageLoading", false)
        .set("error", "")
        .set("communicationPlans", action.data.data)
        .set("communicationPagination", action.data.isForCalendar ? {} : action.data.pagination);
    }
    case ACTIONS.COMMUNICATION_PLAN.ERROR: {
      return state.set("pageLoading", false).set("error", action.error);
    }

    // Create Communication
    case ACTIONS.CREATE_COMMUNICATION_PLAN.PENDING: {
      return state.set("communicationPlanStatusLoading", true).set("error", "");
    }
    case ACTIONS.CREATE_COMMUNICATION_PLAN.SUCCESS: {
      return state
        .set("communicationPlanStatusLoading", false)
        .set("error", "")
        .set("communicationPlans", action.data.data)
        .set("communicationPagination", action.data.isForCalendar ? {} : action.data.pagination);
    }
    case ACTIONS.CREATE_COMMUNICATION_PLAN.ERROR: {
      return state
        .set("communicationPlanStatusLoading", false)
        .set("error", action.error);
    }

    // Update Communication
    case ACTIONS.UPDATE_COMMUNICATION_PLAN.PENDING: {
      return state.set("communicationPlanStatusLoading", true).set("error", "");
    }
    case ACTIONS.UPDATE_COMMUNICATION_PLAN.SUCCESS: {
      return state
        .set("communicationPlanStatusLoading", false)
        .set("error", "")
        .set("communicationPlans", action.data.data)
        .set("communicationPagination", action.data.isForCalendar ? {} : action.data.pagination);
    }
    case ACTIONS.UPDATE_COMMUNICATION_PLAN.ERROR: {
      return state
        .set("communicationPlanStatusLoading", false)
        .set("error", action.error);
    }

    // Delete Communication
    case ACTIONS.DELETE_COMMUNICATION_PLAN.PENDING: {
      return state.set("error", "").set("communicationPlanStatusLoading", true);
    }
    case ACTIONS.DELETE_COMMUNICATION_PLAN.SUCCESS: {
      return state
        .set("communicationPlanStatusLoading", false)
        .set("error", "")
        .set("communicationPlans", action.data.data)
        .set("communicationPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_COMMUNICATION_PLAN.ERROR: {
      return state
        .set("error", action.error)
        .set("communicationPlanStatusLoading", false);
    }

    case ACTIONS.SORT_COMMUNICATION_PLANS.PENDING: {
      return state.set("error", "").set("pageLoading", true);
    }
    case ACTIONS.SORT_COMMUNICATION_PLANS.SUCCESS: {
      return state
        .set("error", "")
        .set("pageLoading", false)
        .set("communicationPlans", action.data.data)
        .set("communicationPagination", action.data.pagination);
    }
    case ACTIONS.SORT_COMMUNICATION_PLANS.ERROR: {
      return state.set("error", action.error).set("pageLoading", false);
    }

    default: {
      return state;
    }
  }
}
